import { AbstractResultList } from './AbstractResultList';
import { ReferenceCriteriaListEntry } from '../ListEntries/ReferenceCriteriaListEntry';

export class ReferenceCriteriaResultList extends AbstractResultList<ReferenceCriteriaListEntry> {}
